export default class AuthException extends Error {}
